import React, { Component } from "react";
import { Link } from "react-router-dom";
import MedicalConsentHeader from "./MedicalConsentHeader";
import Content from "../../content/Content";
import Store from "../../content/Store";
import CheckboxInputGroup from "../shared/CheckboxInputGroup";
import TextInput from "../shared/form/TextInput";
import { isFieldDefined } from "../../validations/RequiredFieldValidator";
import DisplayValidationErrors from "../../components/shared/DisplayValidationErrors";
import Button from "../shared/buttons/Button";

export default class ProvideDeclaration extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorMessages: [],
      assessAndReviewHasError: false,
      auditHealthcareHasError: false,
      iAmThePatientHasError: false,
      isPatientUnder16HasError: false,
      isPatientsParentHasError: false,
      patientNameHasError: false,
      relationshipToPatientHasError: false,
      seeReportHasError: false
    };
    this.validate = this.validate.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  validate() {
    let errors = [];

    let isAxaLayout = this.props.isAxaLayout;

    let isAssessAndReviewDefined = isFieldDefined(
      this.props.medicalConsent.assessAndReview
    );
    let isAuditHealthcareHasErrorDefined = isFieldDefined(
      this.props.medicalConsent.auditHealthcare
    );
    let isIAmThePatientHasErrorDefined = isFieldDefined(
      this.props.medicalConsent.iAmThePatient
    );
    let isSeeReportDefined = isFieldDefined(
      this.props.medicalConsent.seeReport
    );

    let isNotThePatient = this.props.medicalConsent.iAmThePatient === "no";
    let isPatientUnder16Defined = isFieldDefined(
      this.props.medicalConsent.isPatientUnder16
    );

    let patientIsUnder16 = this.props.medicalConsent.isPatientUnder16 === "yes";
    let isPatientsParentDefined = isFieldDefined(
      this.props.medicalConsent.isPatientsParent
    );

    let isPatientNameHasErrorDefined = isFieldDefined(
      this.props.medicalConsent.patientName
    );
    let isRelationshipToPatientDefined = isFieldDefined(
      this.props.medicalConsent.relationshipToPatient
    );

    if (
      !isAssessAndReviewDefined ||
      !isAuditHealthcareHasErrorDefined ||
      !isIAmThePatientHasErrorDefined ||
      !isSeeReportDefined
    ) {
      errors.push(Store.MedicalConsent.ValidationErrors.AllFieldsRequired);
    } else if (isNotThePatient && !patientIsUnder16) {
      errors.push(Store.MedicalConsent.ProvideDeclarationPatientOver16Message);
    } else if (
      isNotThePatient &&
      patientIsUnder16 &&
      !isPatientsParentDefined
    ) {
      errors.push(Store.MedicalConsent.ValidationErrors.AllFieldsRequired);
    } else if (
      isAxaLayout &&
      isNotThePatient &&
      (!isPatientUnder16Defined ||
        !isPatientNameHasErrorDefined ||
        !isRelationshipToPatientDefined)
    ) {
      errors.push(Store.MedicalConsent.ValidationErrors.AllFieldsRequired);
    }

    this.setState({
      assessAndReviewHasError: !isAssessAndReviewDefined,
      auditHealthcareHasError: !isAuditHealthcareHasErrorDefined,
      iAmThePatientHasError: !isIAmThePatientHasErrorDefined,
      seeReportHasError: !isSeeReportDefined,
      isPatientUnder16HasError:
        (isNotThePatient && !isPatientUnder16Defined) ||
        (isNotThePatient && !patientIsUnder16),
      isPatientsParentHasError: patientIsUnder16 && !isPatientsParentDefined,
      patientNameHasError:
        isAxaLayout && isNotThePatient && !isPatientNameHasErrorDefined,
      relationshipToPatientHasError:
        isNotThePatient && !isRelationshipToPatientDefined
    });

    return errors;
  }

  onSubmit(event) {
    event.preventDefault();
    let errorMessages = this.validate();
    if (errorMessages.length === 0) {
      this.props.provideDeclarationOnSubmit(event);
    } else {
      this.setState({
        errorMessages: errorMessages
      });
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }

  render() {
    return (
      <React.Fragment>
        <MedicalConsentHeader
          pageTitle={
            <Content name={Store.MedicalConsent.ProvideDeclarationPageTitle} />
          }
          pageBody={
            <Content name={Store.MedicalConsent.ProvideDeclarationPageBody} />
          }
        />

        <DisplayValidationErrors
          heading={this.props.errorValidationHeading}
          errors={this.state.errorMessages}
        />

        <form onSubmit={event => this.onSubmit(event)}>
          <CheckboxInputGroup
            hasError={this.state.assessAndReviewHasError}
            inputValue={this.props.medicalConsent.assessAndReview}
            groupName="assessAndReview"
            onChange={this.props.onChange}
            groupHeader={
              <Content
                name={
                  Store.MedicalConsent
                    .ProvideDeclarationAssessAndSubsequentLabel
                }
              />
            }
          />
          <CheckboxInputGroup
            hasError={this.state.auditHealthcareHasError}
            inputValue={this.props.medicalConsent.auditHealthcare}
            groupName="auditHealthcare"
            onChange={this.props.onChange}
            groupHeader={
              <Content
                name={
                  Store.MedicalConsent.ProvideDeclarationAuditHealthcareLabel
                }
              />
            }
          />
          <TextInput
            inputId="loggedInUserFullName"
            label={
              <Content
                name={Store.MedicalConsent.ProvideDeclarationYourNameLabel}
              />
            }
            disabled={true}
            inputValue={this.props.medicalConsent.loggedInUserFullName}
          />
          <CheckboxInputGroup
            hasError={this.state.iAmThePatientHasError}
            inputValue={this.props.medicalConsent.iAmThePatient}
            groupName="iAmThePatient"
            onChange={this.props.onChange}
            groupHeader={
              <Content
                name={Store.MedicalConsent.ProvideDeclarationIAmThePatientLabel}
              />
            }
          />
          <div
            id="iAmNotThePatientSection"
            className={
              this.props.medicalConsent.iAmThePatient === "no" ? "" : "d-none"
            }
          >
            <CheckboxInputGroup
              hasError={this.state.isPatientUnder16HasError}
              inputValue={this.props.medicalConsent.isPatientUnder16}
              groupName="isPatientUnder16"
              onChange={this.props.onChange}
              groupHeader={
                <Content
                  name={
                    Store.MedicalConsent.ProvideDeclarationPatientUnder16Label
                  }
                />
              }
            />
            <span
              id="isParentOrGuardianSection"
              className={
                this.props.medicalConsent.isPatientUnder16 === "yes"
                  ? ""
                  : "d-none"
              }
            >
              <CheckboxInputGroup
                hasError={this.state.isPatientsParentHasError}
                inputValue={this.props.medicalConsent.isPatientsParent}
                groupName="isPatientsParent"
                onChange={this.props.onChange}
                groupHeader={
                  <Content
                    name={
                      Store.MedicalConsent.ProvideDeclarationPatientParentLabel
                    }
                  />
                }
              />
            </span>
            <div
              id="PatientOver16Section"
              className={
                this.props.medicalConsent.isPatientUnder16 === "no"
                  ? "alert alert-danger mt-3"
                  : "d-none"
              }
              role="alert"
            >
              <Content
                name={
                  Store.MedicalConsent.ProvideDeclarationPatientOver16Message
                }
              />
            </div>
            <div
              id="patientDetailsSection"
              className={
                this.props.medicalConsent.isPatientUnder16 === "no" ||
                this.props.medicalConsent.isPatientUnder16 === ""
                  ? "d-none"
                  : ""
              }
            >
              <div
                id="isPatientNameSection"
                className={this.props.isAxaLayout === false ? "d-none" : ""}
              >
                <TextInput
                  hasError={this.state.patientNameHasError}
                  inputValue={this.props.medicalConsent.patientName}
                  inputId="patientName"
                  onChange={this.props.onChange}
                  label={
                    <Content
                      name={
                        Store.MedicalConsent.ProvideDeclarationPatientNameLabel
                      }
                    />
                  }
                />
              </div>
              <TextInput
                hasError={this.state.relationshipToPatientHasError}
                inputValue={this.props.medicalConsent.relationshipToPatient}
                inputId="relationshipToPatient"
                onChange={this.props.onChange}
                label={
                  <Content
                    name={
                      Store.MedicalConsent
                        .ProvideDeclarationYourRelationshipLabel
                    }
                  />
                }
              />
            </div>
          </div>
          <CheckboxInputGroup
            hasError={this.state.seeReportHasError}
            inputValue={this.props.medicalConsent.seeReport}
            groupName="seeReport"
            onChange={this.props.onChange}
            groupHeader={
              <Content
                name={Store.MedicalConsent.ProvideDeclarationSeeReportLabel}
              />
            }
          />

          <p>
            <Content name={Store.MedicalConsent.ProvideDeclarationFooterText} />
          </p>

          <div className="row my-5">
            <div className="col-sm-6 back-button">
              <p className="axa-body-text-4 mt-2">
                <Link
                  id="backButton"
                  to=""
                  onClick={event =>
                    this.props.previousContentHandleBackClick(event)
                  }
                >
                  <span className="mr-2 left-arrow-back">←</span>{" "}
                  {this.props.buttonBackText}
                </Link>
              </p>
            </div>
            <div
              className="col-sm-6 text-right"
              id="provideDeclarationSubmitButton"
            >
              <Button label={this.props.nextButton} />
            </div>
          </div>
        </form>
      </React.Fragment>
    );
  }
}
